import React from "react";
import PropTypes from "prop-types";
import "./RadioButton.scss";

const RadioButton = ({
  id,
  name,
  value,
  label,
  checked,
  onChange,
  disabled,
}) => {
  return (
    <label
      className={`radio-button ${disabled ? "radio-button--disabled" : ""}`}
      htmlFor={id}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="radio-button__input"
      />
      <span className="radio-button__custom" />
      <span className="radio-button__label">{label}</span>
    </label>
  );
};

RadioButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RadioButton.defaultProps = {
  checked: false,
  disabled: false,
};

export default RadioButton;
